import { ToastButton, ToastOptions } from '@ionic/react';
import { HookOverlayOptions } from '@ionic/react/dist/types/hooks/HookOverlayOptions';
import { DevSettings } from '../support/DevSettings';

export type IInAppNotificationButton = ToastButton & {
    text: string;
    handler: () => boolean | void | Promise<void>;
};

export type IInAppNotificationOptions = HookOverlayOptions & {
    message: string;
    header?: string;
    duration?: number;
    buttons?: IInAppNotificationButton[];
}

export class InAppNotificationPresenter {
    static inject = () => [DevSettings];
    constructor(private devSettings: DevSettings){}

    private isVisible = false;

    private queue: IInAppNotificationOptions[] = [];

    // unusual naming on purpose, this is called once by ToastBinder and isn't part of the surface area other consumers should use
    _setToastMethods = ({ showToast }: {showToast: (options: ToastOptions & HookOverlayOptions) => Promise<void>}) => {
        this._showToast = showToast;

        // if something was already queued up, show it
        this.showNextIfPossible();
    };

    showNextIfPossible = () => {
        if (this.isVisible || this.queue.length === 0){
            return;
        }

        this.isVisible = true;
        const options = this.queue.shift();

        this._showToast!({
            ...options,
            mode: 'ios',
            position: 'top',
            cssClass: 'custom-toast',
            onDidDismiss: (event) => {
                if (options?.onDidDismiss) {
                    options.onDidDismiss(event);
                }

                // without this timeout, when showNextIfPossible calls _showToast
                // it silently fails, likely because its state still thinks a toast is visible
                setTimeout(() => {
                    this.isVisible = false;
                    this.showNextIfPossible();
                });

            }
        });
    };

    private _showToast?: (options: ToastOptions & HookOverlayOptions) => Promise<void>;

    /**
     * Never add your own dismiss, because showToast will add it for you when appropriate.
     */
    showNotification = async (options: IInAppNotificationOptions) => {
        options.buttons = options.buttons || [];

        if (this.devSettings.disableToastAutoDismiss && options.duration){
            options.duration = undefined;
        }

        this.queue.push({...options, ...{swipeGesture: 'vertical'}});
        this.showNextIfPossible();
    };
}
